import moment from 'moment';
import React from 'react';

import { getLeaveBalanceUpdateLog } from '../../../actions/LeaveAction';
import Header from '../../../component/common/LeaveHeader';
import CONSTANT from '../../../constant';

class ComponentName extends React.Component<any, any>{
    constructor(props: any) {
        super(props);
        this.state = {
            list: undefined,
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        document.title = CONSTANT.pageTitle.adminSection;

        this.loadList();
    }

    render() {
        const { list } = this.state;
        return (
            <div className="container-fluid">
                <div className="row mb-3">
                    {/* <div className="col-md-2 px-0">
                        <Header />
                    </div> */}
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-12 my-3">
                                <h1 className="page-title">Leaves balance update Log</h1>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 mt-3">
                                <div className="list-container">
                                    <table className="table table-bordered table-hover">
                                        <tbody>
                                            <tr>
                                                <th scope="col">S.No.</th>
                                                <th scope="col">Employee Number</th>
                                                <th scope="col">Name</th>
                                                <th scope="col">Update Type</th>
                                                <th scope="col">Dated</th>
                                            </tr>
                                            {
                                                list === undefined && <tr>
                                                    <td colSpan={10} className="text-center">Loading...</td>
                                                </tr>
                                            }
                                            {
                                                list !== undefined && list.length === 0 && <tr>
                                                    <td colSpan={10} className="text-center">No records found</td>
                                                </tr>
                                            }
                                            {
                                                list !== undefined && list.map((item: any, index: number) => {
                                                    const dated = moment(item.dated);
                                                    return (
                                                        <tr>
                                                            <td>{index + 1}</td>
                                                            <td>{item.employeeNumber}</td>
                                                            <td>{item.name}</td>
                                                            <td>
                                                                {item.type === 'I' ? 'Individual' : 'BULK'}
                                                            </td>
                                                            <td>
                                                                {dated.format('DD MMM YYYY HH:mm:ss A')}
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        )
    }

    loadList = () => {
        getLeaveBalanceUpdateLog().then((res: any) => {
            this.setState({ list: res.result });
        });
    }
}

export default ComponentName;